const constants = {
  loginUrl:
    "https://cms-login.auth.ap-south-1.amazoncognito.com/login?" +
    "response_type=token&" +
    "client_id=6a2ug04sbseq6e4k4lqg2hk2lb&" +
    "redirect_uri=" +
    window.location.origin +
    "&" +
    "state=STATE&" +
    "scope=openid+profile+aws.cognito.signin.user.admin",
  // apiUrl: 'http://localhost:8082/v1/',
  apiUrl:
    "https://a7mgclqse5.execute-api.ap-south-1.amazonaws.com/NMCampaignCMS/",
  categories: [
    "All",
    "Accelerating Growth",
    "Commitment to Social Justice",
    "Development for All",
    "Eliminating Corruption",
    "Harnessing Yuva Shakti",
    "Healthy India",
    "Infrastructure for New India",
    "Putting Farmers First",
    "Speed and Scale of Transformation",
    "World sees India",
    "Women Led Development",
  ],
  type: ["Pledge", "Wish"],
  languages: ["english", "hindi"],
  Language: {
    en: "english",
    hi: "hindi",
  },
};
export { constants };



// WEBPACK FOOTER //
// ./src/Bootstrap.jsx